import { Observable } from 'rxjs/Rx'
import 'rxjs/add/operator/merge'
import { tourLoaded, isActionType } from 'aria-viewer/utils/epicsCommon'
import { TourActions } from 'aria-viewer/tour'
import { mapSelectorsToProps } from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { showDescription } from 'aria-viewer/tour/components/buttons/desktopAudioButton'
import { MEDIA_LOADING_STATUS } from 'aria-viewer/tour/constants'
import idx from 'idx'

export default (action$, store) => {
    window.YV = window.YV || { loaded: null }

    const shouldShowDescription = state => {
        const {
            pointInfo: { description, avatar_url, audio_url },
        } = mapSelectorsToProps(['pointInfo'])()(state)

        const stops = state.getIn(['tour', 'stops'])
        const currentStop = stops.getIn(['list', stops.get('current')])
        const hasIntroMedia = idx(currentStop, _ => _.intro_media) !== null
        const mediaLoaded = state.getIn(['tour', 'mainMedia', 'loadingStatus']) == MEDIA_LOADING_STATUS.loaded

        const isStopIntroPlayed = stops.getIn(['isStopIntroPlayed', idx(currentStop, _ => _.stopid)])

        // If the current stop doesn't have intro video then okay to display description
        // else if there is an intro video in the current stop, then check to see that the intro video was viewed.
        const introMediaCheck = !hasIntroMedia || (hasIntroMedia && isStopIntroPlayed)

        return description != '' && avatar_url == '' && audio_url == '' && introMediaCheck && mediaLoaded
    }

    const tourLoadedSuccessfully$ = action$
        .filter(tourLoaded)
        .distinctUntilChanged()
        .do(_ => (window.YV.loaded = true))

    const tourErrored$ = action$
        .filter(action => isActionType(action, TourActions.LOADING))
        .distinctUntilChanged()
        .delay(30000) // After 30 seconds declared that we have errored
        .takeUntil(tourLoadedSuccessfully$)
        .do(_ => (window.YV.loaded = false))

    const showAvatarDescription$ = action$
        .filter(
            action =>
                (isActionType(action, TourActions.STOP_CHANGED) ||
                    isActionType(action, TourActions.SKIPPED_ALT_MAIN_MEDIA) ||
                    isActionType(action, TourActions.MAIN_MEDIA_LOADING_STATUS)) &&
                shouldShowDescription(store.getState())
        )
        .distinctUntilChanged()
        .mapTo(showDescription())

    return Observable.merge(tourLoadedSuccessfully$, tourErrored$, showAvatarDescription$)
}
